module.exports = __webpack_public_path__ + "static/media/bg.8168988d.png";